import UsuarioController from "@/shared/controllers/usuario/usuarioController";
import GerenciamentoUsuariosLogadosViewModel from "@/shared/view-models/GerenciamentoUsuariosLogadosViewModel";
import AccountLoged from "@/shared/mixins/AccountLoged";

const name = 'GerenciamentoUsuariosLogados'
export default {
  name,

  components: { 
  }, 

  props: { },
  mixins:[AccountLoged],

  mounted () {
    if(!this.hasClaim('Gerenciamento-Usuários Logados')) {
      this.$router.push('/sem-acesso')
    }
   },

  updated () { },

  data () {
    return {
      UsuarioArray: [],
      Colunas: [
        {field: 'userName', header: 'Usuário'}, 
        {field: 'dataFormatada', header:'Data'},
        {field: 'numeroIP', header:'IP'},
        {field: 'descricaoProcessoTexto', header:'Ultimo Processo'}
    ], 
      UsuarioLogadoFiltro: new GerenciamentoUsuariosLogadosViewModel,
      UsuarioLogadoTexto: "",
      informacao: [], 
      Filtro: {
          'global': {value: null, matchMode: this.filtros.CONTAINS},
          'data': {value: null, matchMode: this.filtros.CONTAINS},
          'horario': {value: null, matchMode: this.filtros.CONTAINS},
          'ip': {value: null, matchMode: this.filtros.CONTAINS},
          'ultimoproc': {value: null, matchMode: this.filtros.CONTAINS},
          'ativo': {value: null, matchMode: this.filtros.CONTAINS}
        },
        mensagemvazio: true,
        PeriodoAnaliseArray: [
          { value: 1, text: "5 minutos"},
          { value: 2, text: "15 minutos"},
          { value: 3, text: "30 minutos"},
          { value: 4, text: "1 hora"},
          { value: 5, text: "2 horas"},
          { value: 6, text: "3 horas"}
        ]
        
       }    
     
  },

  methods: { 
    getUsuariosLogados() {
      this.mensagemvazio = false
      UsuarioController.getUsuariosLogados(this.UsuarioLogadoFiltro).requisicao
      .then((res => {
        this.UsuarioArray = res.data.data
      }))
    },
    Logout(data) {
      this.$isLoading(true)
      let UsuarioId = data.usuarioId
      UsuarioController.Logout(UsuarioId).requisicao
      .then(
      )
      .finally(() => {
        this.getUsuariosLogados();  
        this.$isLoading(false);
      })
    },
    limparFiltro(){

    }
  },

  computed: { }, 

};